module.exports = __webpack_public_path__ + "static/media/DENT_PHOTO_ICON.648c2368.png";